import { CanDeactivateFn } from '@angular/router';

/** A route component that keeps a locally-edited draft it can save on demand. */
export interface HasUnsavedDraft {
    /** Save pending changes now; `true` when the draft ends up saved. */
    flushDraft(): Promise<boolean>;
}

export const LEAVE_UNSAVED_MESSAGE = 'Your latest changes could not be saved. Leave anyway?';

/**
 * Leaving the editor (22.13, design §14.8): attempt an immediate save and ask for confirmation
 * only when it does not succeed. A missing component (nothing to save) is always allowed.
 */
export const unsavedDraftGuard: CanDeactivateFn<HasUnsavedDraft> = async (component) => {
    if (!component) {
        return true;
    }
    let saved = false;
    try {
        saved = await component.flushDraft();
    } catch {
        saved = false;
    }
    return saved || window.confirm(LEAVE_UNSAVED_MESSAGE);
};
